export default "__VITE_ASSET__51afa080__"